import React from "react";
import SaveBtn from "../SaveBtn";

// Barre d'enregistrement collante, visible seulement quand le formulaire a
// des modifications non enregistrées. `onCancel` (facultatif) ajoute un bouton
// « Annuler » qui remet le formulaire dans son état enregistré.
const StickySaveBar = ({
  visible = false,
  isSaving = false,
  onSave,
  onCancel = null,
  cancelLabel = "Annuler",
  message = "Modifications non enregistrées",
  label = "Enregistrer",
}) => {
  if (!visible) return null;
  return (
    <div className="sticky-save-bar" role="status">
      <span className="sticky-save-bar__msg">
        <i className="fa fa-pencil" aria-hidden="true" />
        {message}
      </span>
      <span className="sticky-save-bar__actions">
        {onCancel && (
          <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={isSaving}>
            {cancelLabel}
          </button>
        )}
        <SaveBtn
          margin=""
          type="btn-primary"
          className="sticky-save-bar__btn"
          text={label}
          save={onSave}
          isSaving={isSaving}
          isSaved={false}
        />
      </span>
    </div>
  );
};

export default StickySaveBar;
